import { render, staticRenderFns } from "./listSetting.vue?vue&type=template&id=2de10d6e&scoped=true"
import script from "./listSetting.vue?vue&type=script&lang=js"
export * from "./listSetting.vue?vue&type=script&lang=js"
import style0 from "./listSetting.vue?vue&type=style&index=0&id=2de10d6e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de10d6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de10d6e')) {
      api.createRecord('2de10d6e', component.options)
    } else {
      api.reload('2de10d6e', component.options)
    }
    module.hot.accept("./listSetting.vue?vue&type=template&id=2de10d6e&scoped=true", function () {
      api.rerender('2de10d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/crud/components/listSetting.vue"
export default component.exports